import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddOutletLayer from "../components/AddOutletLayer";

export const AddOutlet = () => {
  return (
    <MasterLayout>
      {/* <Breadcrumb title="Add / Edit Outlet" /> */}
      <AddOutletLayer />
    </MasterLayout>
  );
};
